// The subcats.json will be deprecated soon in favor of growth APIs.
// Check https://masterclass-dev.atlassian.net/wiki/spaces/ENG/pages/2809135124/Growth+APIs+0+to+1
/** @deprecated */
export const subcatImportPromiseDeprecated = () =>
  import(
    /* webpackChunkName: "sc3" */
    '@mc/growth-data/subcategories/taxonomyPALM/subcats.json'
  )

/** @deprecated */
export const coursesWithSubcatsImportPromiseDeprecated = () =>
  import(
    /* webpackChunkName: "c-sc3" */
    '@mc/growth-data/subcategories/taxonomyPALM/course_mapping.json'
  )
